import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ECOPortalIntegrationCaseStatsState = {
  ecoPortalCaseStats: {
    apiLoading: false,
    cases: [],
  },
}

export const ECOPortalIntegrationCaseStatsActions = {
  fetchEcoPortalCaseStats: async ({ commit }, caseId) => {
    commit('setEcoPortalIntegrationCaseStatsApiLoading', true)

    return axiosRequest.get(`/legal_cases/${caseId}/eco/stats`).
      then(({ data }) => {
        commit('setEcoPortalIntegrationCaseStats', data || [])
      }).
      catch(handleError).
      finally(_ => commit('setEcoPortalIntegrationCaseStatsApiLoading', false))
  },
}

export const ECOPortalIntegrationCaseStatsGetters = {
  ecoPortalIntegrationCaseStatsApiLoading: state => state.ecoPortalCaseStats.apiLoading,
  ecoPortalIntegrationCaseStats: state => state.ecoPortalCaseStats.cases,
}

export const ECOPortalIntegrationCaseStatsMutations = {
  setEcoPortalIntegrationCaseStatsApiLoading: (state, data) => (state.ecoPortalCaseStats.apiLoading = data),
  setEcoPortalIntegrationCaseStats: (state, data) => (state.ecoPortalCaseStats.cases = data),
}
